import AurCountryFlag from '../../../common/aur-country-flag/AurCountryFlag';
import {Box} from '@mui/material';

const CountryFlagComponent = () => {
  return (
    <>
      <Box>Country Flags</Box>
      <AurCountryFlag countryCode="gb" altText="United Kingdom" />
      &nbsp;
      <AurCountryFlag
        countryCode="us"
        altText="United States"
        height={15}
        width={20}
      />
      &nbsp;
      <AurCountryFlag
        countryCode="ca"
        altText="Canada"
        height={36}
        width={48}
        flagResolution="112x84"
      />
    </>
  );
};

export default CountryFlagComponent;
